// extracted by mini-css-extract-plugin
export var dark = "v_tc";
export var darkcookie = "v_td";
export var tintedcookie = "v_tf";
export var regularcookie = "v_tg";
export var darkbase = "v_th";
export var tintedbase = "v_tj";
export var regularbase = "v_tk";
export var darkraw = "v_tl";
export var tintedraw = "v_tm";
export var regularraw = "v_tn";
export var darkchick = "v_tp";
export var tintedchick = "v_tq";
export var regularchick = "v_tr";
export var darkherbarium = "v_ts";
export var tintedherbarium = "v_tt";
export var regularherbarium = "v_tv";
export var darkholiday = "v_tw";
export var tintedholiday = "v_tx";
export var regularholiday = "v_ty";
export var darkoffline = "v_tz";
export var tintedoffline = "v_tB";
export var regularoffline = "v_tC";
export var darkorchid = "v_tD";
export var tintedorchid = "v_tF";
export var regularorchid = "v_tG";
export var darkpro = "v_tH";
export var tintedpro = "v_tJ";
export var regularpro = "v_tK";
export var darkrose = "v_tL";
export var tintedrose = "v_tM";
export var regularrose = "v_tN";
export var darktimes = "v_tP";
export var tintedtimes = "v_tQ";
export var regulartimes = "v_tR";
export var darkwagon = "v_tS";
export var tintedwagon = "v_tT";
export var regularwagon = "v_tV";